import { Component, OnInit } from "@angular/core";
import { DataService_HallSweepSettings } from "./shared/data.service";
import { SettingsUpdateRequest } from "./shared/SettingsUpdateRequest";
import { ConfirmationService } from "primeng/api";
import * as moment from "moment";

@Component({
	selector: "app-hall-sweep-settings",
	templateUrl: "./hall-sweep-settings.component.html",
	styleUrls: ["./hall-sweep-settings.component.css"],
})
export class HallSweepSettingsComponent implements OnInit {
	constructor(private hsService: DataService_HallSweepSettings, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadPreferences();
	}

	////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////

	AccumulationCount: number = 1;
	AccumulationMode: number = 3;
	lstAccumulationMode: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Days",
		},
		{
			ID: 2,
			Desc: "Weeks",
		},
		{
			ID: 3,
			Desc: "Months",
		},
	];

	PreferenceLoading: boolean = true;
	Processing: boolean = false;

	ExampleDateDesc: string = "";

	errorMessage: string = "";

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////

	loadPreferences() {
		this.errorMessage = "";

		this.PreferenceLoading = true;

		var result = this.hsService.SettingsSelect();
		result.subscribe(
			(response: any) => {
				if (response.AccumulationCount != undefined) {
					this.AccumulationCount = response.AccumulationCount;
				}
				if (response.AccumulationMode != undefined) {
					this.AccumulationMode = response.AccumulationMode;
				}

				this.CalcExampleDate();

				this.PreferenceLoading = false;
			},
			(error) => {
				this.PreferenceLoading = false;
			}
		);
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		if (this.AccumulationMode != 0 && this.AccumulationCount < 1) {
			this.errorMessage = "Enter Count";
			return;
		}

		this.Processing = true;

		var parms: SettingsUpdateRequest = {
			AccumulationCount: this.AccumulationCount,
			AccumulationMode: this.AccumulationMode,
		};

		var result = this.hsService.SettingsUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "hssettings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "CAASS Pass Settings were updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadPreferences();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "hssettings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update CAASS Pass settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////

	onAccumulationCountChange(val) {
		this.AccumulationCount = val;

		this.CalcExampleDate();
	}

	onAccumulationModeChange(val) {
		this.AccumulationMode = val;

		this.CalcExampleDate();
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////

	IsLoading() {
		return this.PreferenceLoading == true || this.Processing == true;
	}

	CalcExampleDate() {
		if (this.AccumulationMode == 0) {
			this.ExampleDateDesc = "";
		} else {
			var StartDate: Date = new Date();

			if (this.AccumulationMode == 1) {
				StartDate = new Date(StartDate.setDate(StartDate.getDate() - this.AccumulationCount));
			} else if (this.AccumulationMode == 2) {
				StartDate = new Date(StartDate.setDate(StartDate.getDate() - this.AccumulationCount * 7));
			} else if (this.AccumulationMode == 3) {
				StartDate = new Date(StartDate.setMonth(StartDate.getMonth() - this.AccumulationCount));
			}

			this.ExampleDateDesc = moment(StartDate).format("MM/DD/YYYY");
		}
	}

	////////////////////////////////////////////////////////
}
